import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);


  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Phone Link"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container-fluid">
            <div className="row">

              <div className="col-md-6 col-sm-12" style={{ marginTop: "30px", paddingBottom: "30px" }}>
                {
                  (appContext.userData.phone && appContext.userData.countryCode) ?
                  <>
                  </>
                  :
                  <>
                    <h4 className="font-light">You have not linked any phone number</h4>
                    <small className="text-muted">Link your phone number to receive alerts, awards and be able to recover you account easily with a phone number</small>
                  </>
                }
              </div>

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
